<template>
    <div class="mobile-menu">
        <div class="mobile-menu__wrapper">
            <catalog
                class="content__catalog"
                :current-article="currentArticle"
                :catalog="catalog"
                :level="level"
                :article-action="articleAction"
                @cat-click="$emit('catClick')"
            />
        </div>
        <div class="mobile-menu__actions">
            <a
                class="mobile-menu__actions-registration"
                :href="!is_intl ? 'https://stocrm.ru/registration/' : 'https://rerada.com/registration'"
            >
                <SquareButton
                    class="mobile-menu__button"
                    :text="getTranslate('registration')"
                    type="button_addit_blue"
                />
            </a>
            <a
                :href="!is_intl ? 'https://stocrm.ru/login' : 'https://rerada.com/login'"
                class="mobile-menu__login"
            >
                {{ getTranslate('login') }}
            </a>
        </div>
    </div>
</template>
<script>
import catalog from '../components/catalog.vue'
import SquareButton from '@/components/SquareButton.vue';

export default {
    name: 'MobileMenu',
    components: {
        SquareButton,
        catalog
    },
    props: {
        catalog: {
            default: () => {},
            type: Object
        },
        level: {
            type: Number,
            default: 0
        },
        currentArticle: {
            type: [Boolean, String],
            default: false,
        },
        articleAction: {
            type: Function,
            default: () => {}
        }
    },
    emits: ['catClick'],
    data() {
        return {}
    },
    mounted() {
        document.querySelector('body').style.overflow = 'hidden'
    },
    unmounted() {
        document.querySelector('body').style.overflow = 'auto'
    },
}
</script>
<style scoped>
.mobile-menu {
    position: fixed;
    top: 75px;
    z-index: 25;
    background: var(--white);
    width: 100%;
    height: calc(100% - 20%);
    box-shadow: 0px 4px 10px 0px #00000026;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
}

.mobile-menu__wrapper {
    width: calc(100% - 40px);
    margin: 0 auto;
    overflow: hidden;
    overflow-y: auto;
    height: inherit;
}

.mobile-menu__wrapper::-webkit-scrollbar {
    display: none;
}

.mobile-menu__actions {
    width: calc(100% - 40px);
    margin: auto auto 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 28px;
    padding: 20px 0;
}
.mobile-menu__actions-registration {
    width: 100%;
}

.mobile-menu__button {
    width: 100%;
}

.mobile-menu__login {
    color: var(--primary-blue);
    font-weight: 600;
    cursor: pointer;
    font-size: 14px;
}
</style>
